export default {
  border: "1px solid #E2E2E2",
  backgroundColor: "white",
  cursor: "pointer"
};
